<template>
  <div v-show="isLoaded" class="mBannerViveLatino-container" v-observe-visibility="startAnimate">
    <img class="mBanner-img" :src="banner" alt="Vive Latino">
    <p class="mBanner-title" :class="{animate: animate}">Regístrate y participa para ganar boletos <br>
    y más premios durante el #VLIndio23</p>
    <div class="mBanner-button" :class="{animate: animate, onlySafari: isSafari}">
        <a href="https://www.indio.com.mx/rockid">
            <span class="button">Obtén tu rock id</span>
        </a>
    </div>
    
  </div>
</template>

<script>
import banner from "@/assets/banner_vivelatino.png";
import { mapGetters } from "vuex";
import Bowser from "bowser"; 
export default {
    name: "BannerViveLatino",
    data() {
        return {
            animate: false,
            isSafari: false,
            banner,
        };
    },
    computed: {
        ...mapGetters(["isLoaded"]),
    },

    methods: {
        startAnimate(isVisible){
            if(isVisible){
                this.animate=true;
            }
        },
    },
    mounted() {
    },
    beforeMount() {
        const browser = Bowser.getParser(window.navigator.userAgent);
        if (browser.getBrowserName()=='Safari') {
            this.isSafari = true
        }
    },
};
</script>

<style scoped lang="scss">
@import "~@/styles/variables.scss";
@import "~@/styles/BannerViveLatino.scss";
</style>